import classNames from 'classnames';
import type { DemoActionsDropdownContentProps } from './types';

export const DemoActionsDropdownContent = ({
  previewDemo,
  archiveDemo,
  duplicateDemo,
  createTourFromDemo,
  copyDemo,
  copyURL,
  editDemo,
  moveDemo,
}: DemoActionsDropdownContentProps) => {
  return (
    <div
      className={classNames('p-2 flex flex-col', {
        'gap-2': editDemo && archiveDemo,
      })}
    >
      <div>
        {previewDemo}
        {editDemo}
        {createTourFromDemo}
        {duplicateDemo}
        {moveDemo}
        {copyDemo}
        {copyURL}
      </div>
      {archiveDemo}
    </div>
  );
};
